"use strict";

exports.__esModule = true;
exports.default = noop;
// Predicate-generating function. Often useful outside of Underscore.
function noop() {}